// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceStyles } from "@conklin/Overrides/Components/ProductPrice";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const priceStyle: TypographyPresentationProps = {
    variant: "h4",
    forwardAs: "p",
    css: css`
        &&& {
            margin: 0;
            line-height: 22px;
            white-space: nowrap;
            display: inline-block;
        }
    `,
};

const unitOfMeasureText: TypographyPresentationProps = {
    size: 12,
    lineHeight: "14px",
    color: "common.ui6",
    css: css`
        white-space: nowrap;
    `,
};

productPriceStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: fit-content;
    `,
};

productPriceStyles.priceWrapper = {
    css: css`
        ${wrapInContainerStyles}
        display: flex;
        align-items: baseline;
        flex-wrap: wrap;
    `,
};
productPriceStyles.packWrapper = {
    css: css`
        margin-bottom: 0;
    `,
};
productPriceStyles.packLabelText = {
    size: 12,
    lineHeight: "14px",
    weight: fontConfig.weight.bold,
};
productPriceStyles.packDescriptionText = {
    size: 12,
    lineHeight: "14px",
};
productPriceStyles.price = {
    unitOfMeasure: {
        unitOfMeasureText,
    },
    realTimeText: {
        weight: fontConfig.weight.bold,
        css: css`
            display: inline-block;
            text-align: left;
            min-width: 25px;

            &::after {
                overflow: hidden;
                display: inline-block;
                vertical-align: bottom;
                animation: ellipsis steps(4, end) 900ms infinite 1s;
                content: "\\2026";
                width: 0;
            }

            @keyframes ellipsis {
                to {
                    width: 1.25em;
                }
            }
        `,
    },
    vatLabelText: {
        css: css`
            font-size: 12px;
        `,
    },
    signInText: {
        size: 12,
        lineHeight: "15px",
    },
    priceText: priceStyle,
    errorText: priceStyle,
    invalidPriceText: priceStyle,
};

productPriceStyles.invalidPriceText = priceStyle;
productPriceStyles.quoteMessage = {
    text: priceStyle,
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText,
};
